export const ToolKitBoxStyles = () => ({
  position: 'absolute',
  width: '64px',
  height: '116px',
  zIndex: '2',
  justifyContent: 'space-between',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  right: '15px',
  // top: 'calc(50% - 78px)', with flash icon => implement later
  top: 'calc(50% - 35px)', // with flash icon is hide => remove later when implement flash feature
  '@media (orientation: portrait)': {
    width: '32px',
    height: '32px',
    top: '85%',
    right: '10px',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  }
});

export const CaptureImageStyles = () => ({
  width: '64px',
  height: '64px',
  '@media (orientation: portrait)': {
    display: 'none'
  }
});

export const FlashIconStyles = ({ theme }) => ({
  border: `1px solid ${theme.palette.border.main}`,
  borderRadius: '50%',
  backgroundColor: `${theme.palette.fixed.black}`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '10px'
});

export const CloseIconStyles = () => ({
  position: 'absolute',
  color: 'white',
  width: '30px',
  height: '30px',
  zIndex: '2',
  right: '5px',
  top: '5px'
});

export const AutoCaptureIconStyles = () => ({
  position: 'absolute',
  zIndex: '2',
  right: '60px',
  top: '13px'
});

export const LoadingCameraStyles = () => ({
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.1)'
});

export const LoadingContainerStyle = () => ({
  height: '100%',
  textAlign: 'center'
});

export const LoadingImageWrapperStyle = () => ({
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%'
});
